import { format, isValid, parseISO } from 'date-fns';
import { ru } from 'date-fns/locale';

export const formatPromoDate = (date: string, dateFormat: string): string => {
  const parsedDate = parseISO(date);

  return isValid(parsedDate) ? format(parsedDate, dateFormat, { locale: ru }) : date;
};
